import { jsxs, jsx } from 'react/jsx-runtime';
import { Page, Header, RoutedTabs } from '@backstage/core-components';
import { attachComponentData, useElementFilter } from '@backstage/core-plugin-api';

const dataKey = "plugin.explore.exploreLayoutRoute";
const Route = () => null;
attachComponentData(Route, dataKey, true);
attachComponentData(Route, "core.gatherMountPoints", true);
const ExploreLayout = (props) => {
  const { title, subtitle, children } = props;
  const routes = useElementFilter(
    children,
    (elements) => elements.selectByComponentData({
      key: dataKey,
      withStrictError: "Child of ExploreLayout must be an ExploreLayout.Route"
    }).getElements().map((child) => child.props)
  );
  return /* @__PURE__ */ jsxs(Page, { themeId: "home", children: [
    /* @__PURE__ */ jsx(
      Header,
      {
        title: title ?? "Explore our ecosystem",
        subtitle: subtitle ?? "Discover solutions available in our ecosystem"
      }
    ),
    /* @__PURE__ */ jsx(RoutedTabs, { routes })
  ] });
};
ExploreLayout.Route = Route;

export { ExploreLayout };
//# sourceMappingURL=ExploreLayout.esm.js.map
